import React, {useEffect} from 'react';
import Header from '../presentations/Header';
import FullScreenContainer from '../presentations/FullScreenContainer';
import LoginForm from '../containers/LoginForm';
import { AppState } from '../stores';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Redirect, useHistory } from 'react-router';
import { appEnv } from '../config/env';
import Authentication from '../services/authentication';

const Login = () => {
  const { t } = useTranslation();
  const user = useSelector((state: AppState) => state.authenticated.user);
  const accessTokenExpiresAt = useSelector(
    (state: AppState) => state.authenticated.accessTokenExpiresAt,
  );
  const history = useHistory();
  const authentication = new Authentication();
  const isAuthenticated = !!user && authentication.isSessionValid(accessTokenExpiresAt);

  useEffect(() => {
    document.title = `${appEnv.name} - ${t('Login')}`;
    if (isAuthenticated) {
      history.push('/')
    }
  }, [history, isAuthenticated, t]);

  if (isAuthenticated) {
    return <Redirect to="/" />;
  }

  return (
          <>
            <Header/>

            <FullScreenContainer centering={true}>
              <main>
                <LoginForm/>
              </main>
            </FullScreenContainer>
          </>
  );
};

export default Login;
